import { render, staticRenderFns } from "./QuestionarieResult.vue?vue&type=template&id=8ad41d84&scoped=true"
import script from "./QuestionarieResult.vue?vue&type=script&lang=js"
export * from "./QuestionarieResult.vue?vue&type=script&lang=js"
import style0 from "./QuestionarieResult.vue?vue&type=style&index=0&id=8ad41d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad41d84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyDisclosureSubsectionScore: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/DisclosureSubsectionScore.vue').default,IxSurveyEsgSubsectionScore: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgSubsectionScore.vue').default,IxSubSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSectionTitle.vue').default,IxSubSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSectionText.vue').default,IxSubSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSection.vue').default,IxSurveySdgGriRelevantExplanation: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/SdgGriRelevantExplanation.vue').default})
